
const HigherEducation = () => {
    return (
        <div>
            <h1>Higher Education</h1>
        </div>
    )
}

export default HigherEducation
